import * as country from '../../../apis/country'
import { createSelector } from 'reselect'
import * as cookies from '../../../utilties/cookies'

const FETCH_COUNTRIES_REQUESTED = 'FETCH_COUNTRIES_REQUESTED'
const FETCH_COUNTRIES_SUCCESS = 'FETCH_COUNTRIES_SUCCESS'
const FETCH_COUNTRIES_FAILED = 'FETCH_COUNTRIES_FAILED'

export const fetchCountries = (languageId) => (dispatch) => {
	dispatch({ type: FETCH_COUNTRIES_REQUESTED, data: {} })
	
	country.fetchCountries(languageId).then((proms) => {
		if (proms) {
			return dispatch({ type: FETCH_COUNTRIES_SUCCESS, data: proms })
		} else if(!proms || !proms.redirectTo) {
			return dispatch({ type: FETCH_COUNTRIES_FAILED, data: {} })
		}
	})
	
	return
}

export const fetchCountriesByLocale = (locale) => (dispatch) => {
	dispatch({ type: FETCH_COUNTRIES_REQUESTED, data: {} })
	
	country.fetchCountriesByLocale(locale).then((proms) => {
		if (proms) {
			return dispatch({ type: FETCH_COUNTRIES_SUCCESS, data: proms })
		} else if(!proms || !proms.redirectTo) {
			return dispatch({ type: FETCH_COUNTRIES_FAILED, data: {} })
		}
	})
	
	return
}

const initial = {
	countries: []
}

export const reducer = (state = initial, action) => {
	switch (action.type) {
		case FETCH_COUNTRIES_SUCCESS:
			return { ...state, countries: action.data }
		default:
			return { ...state }
	}
}

export const countriesSelector = (state) => state.country.countries

export const countryListSelector = (state) => {
	if (state.country.countries) {
		return state.country.countries.map((r) => {
			return {
				id: r.id,
				label: r.name,
				abbreviation: r.abbreviation
			}
		})
	}
	return []
}